
export default {
  name: 'CommercialOperationBadge',
  props: {
    value: {
      type: Number,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    onDark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      prefix: 'components.commercialOperationBadge',
    }
  },
}
